var _g, _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVehicleInquiry(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2962_5566)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22 33C28.0751 33 33 28.0751 33 22C33 15.9249 28.0751 11 22 11C15.9249 11 11 15.9249 11 22C11 28.0751 15.9249 33 22 33Z",
    fill: "#667080"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.0295 22.5314V21.3237L24.5221 18H14V24.6475H15.5292C15.8238 25.2901 16.5955 25.7554 17.5074 25.7554C18.4193 25.7554 19.1909 25.2901 19.4855 24.6475H25.3569C25.6936 25.3898 26.6616 25.8939 27.7559 25.7222C28.5696 25.5948 29.236 25.074 29.3904 24.4315C29.6078 23.5673 28.9695 22.7973 28.0295 22.5314ZM26.2057 21.3237H24.5221V19.7283L26.2057 21.3237ZM15.4029 19.1079H18.2088V21.3237H15.4029V19.1079ZM17.5074 24.6475C17.1216 24.6475 16.8059 24.3982 16.8059 24.0935C16.8059 23.7889 17.1216 23.5396 17.5074 23.5396C17.8932 23.5396 18.2088 23.7889 18.2088 24.0935C18.2088 24.3982 17.8932 24.6475 17.5074 24.6475ZM19.6118 23.5396V22.4317H21.7162V21.3237H19.6118V19.1079H23.1192V23.5396H19.6118ZM27.328 24.6475C26.9422 24.6475 26.6265 24.3982 26.6265 24.0935C26.6265 23.7889 26.9422 23.5396 27.328 23.5396C27.7138 23.5396 28.0295 23.7889 28.0295 24.0935C28.0295 24.3982 27.7138 24.6475 27.328 24.6475Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2962_5566",
    x: 0,
    y: 0,
    width: 46,
    height: 46,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 1,
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.490196 0 0 0 0 0.6 0 0 0 0 0.705882 0 0 0 0.2 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2962_5566"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2962_5566",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVehicleInquiry);
export default __webpack_public_path__ + "static/media/vehicle_inquiry.d5e6c5912f85aaa92cb1cfe72476e299.svg";
export { ForwardRef as ReactComponent };